module.exports = __webpack_public_path__ + "static/media/ufo-beam.6e634231.svg";